import * as descendants from "./descendants.js";
import * as elementIdMap from "./element-id-map.js";
/**
 * @public
 */
export var Query;
(function (Query) {
    Query.getDescendants = descendants.getDescendants;
    Query.getElementDescendants = descendants.getElementDescendants;
    Query.getElementIdMap = elementIdMap.getElementIdMap;
    Query.getInclusiveElementDescendants = descendants.getInclusiveElementDescendants;
})(Query || (Query = {}));
//# sourceMappingURL=index.js.map